import http from '../../axios';
import {ArenaLeague, ArenaState, BattleLog, FighterDto, LeagueDto, LeaguesDto} from "@/store/arena/types";
import PlayerStore from "@/store/player";
import {PayType, Player} from "@/store/player/types";
import PlaceStore from "@/store/place";

export default class ArenaStore {

    private static state: ArenaState = {
        opponent: undefined,
    };

    private static SET_OPPONENT(opponent: FighterDto) {
        ArenaStore.state.opponent = opponent;
    }

    public static getOpponent(): FighterDto {
        return ArenaStore.state.opponent!;
    }

    public static ensureOpponent(): Promise<FighterDto> {
        return http.post('/api/arena/opponent/ensure')
            .then(r => r.data)
            .then(opponentObj => {
                let opponent: FighterDto = Object.assign(new FighterDto(), opponentObj);
                ArenaStore.SET_OPPONENT(opponent);
                return opponent;
            });
    };

    public static changeOpponent(): Promise<FighterDto> {
        return http.post('/api/arena/opponent/change')
            .then(r => r.data)
            .then(opponentObj => {
                let opponent: FighterDto = Object.assign(new FighterDto(), opponentObj);
                ArenaStore.SET_OPPONENT(opponent);
                PlayerStore.SET_BALANCE(opponent.balance);
                return opponent;
            });
    };

    public static speedupArena(payType: PayType): Promise<FighterDto> {
        return http.post('/api/arena/' + payType + '/speedup')
            .then(r => r.data)
            .then(opponentObj => {
                let opponent: FighterDto = Object.assign(new FighterDto(), opponentObj);
                ArenaStore.SET_OPPONENT(opponent);
                PlayerStore.SET_BALANCE(opponent.balance);
                return opponent;
            });
    };

    public static getBattleLog(): Promise<BattleLog[]> {
        return http.get('/api/arena/log')
            .then(r => r.data)
            .then(logs => {
                return logs;
            });
    };

    public static getLeaguesDto(): Promise<LeaguesDto> {
        return http.get('/api/arena/leagues')
            .then(r => r.data)
            .then(leagues => {
                return leagues;
            });
    }

    public static takeDailyReward(): Promise<void> {
        return http.get('/api/arena/take/daily/reward')
            .then(r => r.data)
            .then((playerObj) => {
                let player: Player = Object.assign(new Player(), playerObj);
                PlayerStore.SET_PLAYER(player);
            });
    }

    public static setRewardTimeOffset(offsetHours: number): Promise<number> {
        var params = new URLSearchParams();
        params.append('hoursOffset', String(offsetHours));
        return http.post('/api/arena/set/reward/time/offset', params)
            .then(r => r.data)
            .then((remainMillis) => {
                return remainMillis;
            });
    }

}
